import React from "react";
import { Link } from "@quintype/components";

import { MediaObject } from "../basic/media-object-list.js"
import { SectionName } from "../basic/section-name.js";

import { DfpAd } from "../dfp-ad";

function FullscreenMediaList(props) {
  const mediaObjectConfig = {
    section: !props.hideSectionName,
    enlarged: true,
    noBackground: true,
    storyTime: true,
    aspectRatio: [5,3]
  }
  
  const limit = props.config.limit || 3;

  if(props.stories.length < 1) {
    return <div></div>
  }

  return <div className="fullscreen-media-list">
    <div className="fullscreen-media-list__content component-wrapper">
      {
        !props.HideSectionName && <SectionName className="fullscreen-media-list__section-name" hideLink={true} name={props.config['collection-name']} type="large" section={props.config['collection-section']}/>
      }
      <div className="fullscreen-media-list__stories">
        {props.stories.slice(0,limit)
          .map(storyObj => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return <div className="fullscreen-media-list__object" data-load-more-object="true" key={story.id}>
              <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config['collection-color']}/>
            </div>
          }
        )}
        { !props.hideLoadmore &&
          <div className="fullscreen-media-list__load-more"  data-load-more="true">
            {
              props.getMoreStories ? <a onClick={props.getMoreStories}>Load more</a> :
              <Link href={'/' + props.config['collection-slug']}>
                Read more
              </Link>
            }
          </div>
        }
      </div>
      <div>
        {
          props.adSlot && <div className="app-ad app-ad--vertical">
            <DfpAd adtype="Vertical-Ad" layoutName="FullscreenMediaList" collectionSlug={props.config['collection-slug']}/>
          </div>
        }
      </div>
    </div>
  </div>
}

export { FullscreenMediaList };
